import { useState, useMemo, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import EmployeeList from "./EmployeeList";
import {
  fetchData,
  updateSchoolPayDate,
  updateSchoolPhoneNumber,
  updateSchoolPSEditPin,
  updateSchoolAnydeskId,
  updateCloseMaliaAction,
  updateCloseEmployeeAction,
  updateCloseStudentsAction,
  updateCloseModeerAction,
  deleteSchool,
  updateCanAddStore,
  changeStatusSchoolAction,
} from "../../redux/slices/mainDataSlice";
import { toast } from "react-hot-toast";
import UnifiedDatePicker from "../../components/UnifiedDatePicker";
import Can from "../../permissions/Can";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faToggleOn,
  faToggleOff,
  faTrashCan,
  faMessage,
  faEnvelopeOpenText,
  faArrowRightToBracket,
  faArrowRightFromBracket,
  faHistory,
  faGraduationCap,
  faMoneyBill,
  faUserTie,
  faUserFriends,
  faPhoneVolume,
  faDesktop,
  faLock,
  faUserShield,
  faRobot,
  faEdit,
  faCalendarAlt,
  faMapMarkerAlt,
  faDatabase,
  faMars,
  faVenus,
} from "@fortawesome/free-solid-svg-icons";
import request from "../../api/request";
import Tooltip from "../../components/Tooltip";

const safeDate = (val) => {
  try {
    const d = new Date(val);
    if (!val || isNaN(d.getTime()) || d.getFullYear() < 1950) return "—";

    const pad = (n) => n.toString().padStart(2, "0");

    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1); // رقم الشهر
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());

    // صيغة: YYYY-MM-DD HH:MM
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } catch {
    return "—";
  }
};

const safeISODate = (val) => {
  try {
    const d = new Date(val);
    if (!val || isNaN(d.getTime()) || d.getFullYear() < 1950) return "—";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch {
    return "—";
  }
};

const safeDay = (val) => {
  try {
    const d = new Date(val);
    if (!val || isNaN(d.getTime()) || d.getFullYear() < 1950) return "—";
    const days = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
    return days[d.getDay()];
  } catch {
    return "—";
  }
};

const safeTime = (val) => {
  try {
    const d = new Date(val);
    if (!val || isNaN(d.getTime()) || d.getFullYear() < 1950) return "—";
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'م' : 'ص';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const hoursStr = String(hours).padStart(2, '0');
    return `${hoursStr}:${minutes}:${seconds} ${ampm}`;
  } catch {
    return "—";
  }
};

// أسماء حقول جدول الثوابت بالعربية (للعرض في جدول ثوابت المدرسة)
const THAWABET_FIELD_LABELS = {
  rgmw: "الرقم الوطني",
  school_rgmwtni: "الرقم الوطني للمدرسة",
  school_name: "اسم المدرسة",
  school_number: "رقم المدرسة",
  Modeeria_name_a: "اسم المديرية",
  AlModeeria_name_a: "اسم المديرية عربي",
  headMaster_Name: "اسم المدير",
  Modeeria_name_e: "اسم المديرية (إنج)",
  school_address: "عنوان المدرسة",
  phone: "الهاتف",
  education_level: "المرحلة التعليمية",
  school_type: "نوع المدرسة",
  School_type: "نوع المدرسة",
  gender_type: "نوع الجنس",
  id: "المعرف",
  school_year: "العام الدراسي الحالي",
  Semester: "الفصل الدراسي",
  HeadMaster_jens: "جنس المدير",
  hedmaster_name: "اسم المدير بالانجليزية",
  AlModeeria_name_e: "اسم المديرية انجليزي",
  City: "المدينة",
  School_gender: "جنس المدرسة",
  Director_Name: "اسم مدير التربية",
  school_oredoo: "رقم اريدو المدرسة",
  SchoolMail: "ايميل المدرسة",
  School_webPage: "صفحة المدرسة",
  DBPathNew: "موقع داتا الفارس",
  ShEmail: "ايميل قسم الامتحانات",
  SchoolPlace: "موقع المدرسة",
  School_phone: "هاتف المدرسة",
  sh3ab: "عدد الشعب",
};

const IGNORED_THAWABET_FIELDS = [
  "school_number",
  "School_reference",
  "al_sader",
  "pass",
  "mpass",
  "SchoolCode",
  "Head_segn",
  "HeadSignPath",
  "SchoolStampPath",
  "chkShowImages",
];

const renderThawabetValue = (key, value) => {
  if (value == null || value === "") return "—";
  const strVal = String(value);

  // جنس المدير
  if (key === "HeadMaster_jens") {
    if (strVal === "1") {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FontAwesomeIcon icon={faVenus} style={{ color: "#ec4899" }} />
          أنثى
        </span>
      );
    }
    if (strVal === "2") {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FontAwesomeIcon icon={faMars} style={{ color: "#3b82f6" }} />
          ذكر
        </span>
      );
    }
  }

  // نوع المدرسة
  if (key === "School_type" || key === "school_type") {
    const map = {
      1: { text: "أساسي", icon: faGraduationCap, color: "#10b981" },
      2: { text: "ثانوي", icon: faGraduationCap, color: "#f59e0b" },
      3: { text: "أساسي وثانوي", icon: faGraduationCap, color: "#3b82f6" },
    };
    const item = map[strVal];
    if (item) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FontAwesomeIcon icon={item.icon} style={{ color: item.color }} />
          {item.text}
        </span>
      );
    }
    return value;
  }

  // جنس المدرسة
  if (key === "School_gender" || key === "gender_type") {
    const map = {
      1: { text: "ذكور", icon: faMars, color: "#3b82f6" },
      2: { text: "إناث", icon: faVenus, color: "#ec4899" },
      3: { text: "مختلطة", icon: faUserFriends, color: "#a855f7" },
    };
    const item = map[strVal];
    if (item) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FontAwesomeIcon icon={item.icon} style={{ color: item.color }} />
          {item.text}
        </span>
      );
    }
    return value;
  }

  // الفصل الدراسي
  if (key === "Semester") {
    const map = {
      1: { text: "الفصل الأول", color: "#10b981" },
      2: { text: "الفصل الثاني", color: "#f59e0b" },
    };
    const item = map[strVal];
    if (item) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FontAwesomeIcon icon={faCalendarAlt} style={{ color: item.color }} />
          {item.text}
        </span>
      );
    }
    return value;
  }

  // المدينة
  if (key === "City") {
    return (
      <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: "#ef4444" }} />
        {value}
      </span>
    );
  }

  // موقع المدرسة
  if (key === "SchoolPlace") {
    return (
      <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: "#ef4444" }} />
        {value}
      </span>
    );
  }

  return strVal;
};

export default function SchoolDetails() {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { rgmw } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const schoolsData = useSelector((state) => state.main.data?.schoolData);
  const anydeskData = useSelector((state) => state.main.data?.anydeskData);
  const allTeachers = useSelector((state) => state.main.data?.allteachers);
  const thawabetData = useSelector((state) => state.main.data?.thawabetData);

  const thawabetRow = useMemo(
    () =>
      (thawabetData || []).find(
        (row) => String(row.school_rgmwtni || row.rgmw) === String(rgmw)
      ),
    [thawabetData, rgmw]
  );

  const school = useMemo(
    () => (schoolsData || []).find((s) => String(s.rgmw) === String(rgmw)),
    [schoolsData, rgmw]
  );

  const [activeTab, setActiveTab] = useState("profile");
  const [newPayDate, setNewPayDate] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [modeerPass, setModeerPass] = useState("");
  const [loadingPass, setLoadingPass] = useState(false);
  const [placeName, setPlaceName] = useState("");

  // Editing Name
  const [showEditNameModal, setShowEditNameModal] = useState(false);
  const [newName, setNewName] = useState("");

  // Message Modal
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageText, setMessageText] = useState("");
  
  // Login History Modal
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginHistory, setLoginHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const schoolRgmw = school?.rgmw;
  useEffect(() => {
    if (!schoolRgmw) return;
    const fetchPass = async () => {
      setLoadingPass(true);
      try {
        const token = JSON.parse(
          localStorage.getItem("userCredentials")
        )?.token;
        if (!token) return;
        const response = await request.get(
          `/api/alfares/schools/modeerpass/${schoolRgmw}/${token}`,
          {
            // نعتبر 404 حالة طبيعية (لا توجد كلمة مرور مدير) حتى لا يُعتبر خطأ
            validateStatus: (status) =>
              (status >= 200 && status < 300) || status === 404,
          }
        );

        if (response.status === 404 || !response.data?.modeerpass) {
          setModeerPass("—");
        } else {
          setModeerPass(response.data.modeerpass);
        }
      } catch (e) {
        setModeerPass("—");
      } finally {
        setLoadingPass(false);
      }
    };
    fetchPass();
  }, [schoolRgmw]);

  // جلب اسم المكان (place_name) من school_placestbl عبر API مخصص يعتمد على rgmw
  useEffect(() => {
    if (!schoolRgmw) return;
    const fetchPlace = async () => {
      try {
        const token = JSON.parse(
          localStorage.getItem("userCredentials")
        )?.token;
        if (!token) return;
        const response = await request.get(
          `/api/alfares/schools/place/${schoolRgmw}/${token}`
        );
        setPlaceName(response.data?.place_name || "");
      } catch {
        setPlaceName("");
      }
    };
    fetchPlace();
  }, [schoolRgmw]);

  const handleToggle = async (currentStatus) => {
    const newStatus = currentStatus === "on" ? "off" : "on";
    const token = JSON.parse(localStorage.getItem("userCredentials"))?.token;
    const finalURL = `https://api.alfares.cloud/api/alfares/schools/updateStatus/${school.rgmw}/${newStatus}/${token}`;

    try {
      const res = await fetch(finalURL, { method: "POST" });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "فشل التحديث");

      dispatch({
        type: "main/updateSchoolStatusLocal",
        payload: { rgmw: school.rgmw, newStatus },
      });
      toast.success("تم تحديث الحالة");

      // مسح تاريخ التمديد عند التعطيل — عملية ثانوية لا تُفشل العملية الأساسية
      if (newStatus === "off") {
        try {
          await dispatch(
            updateSchoolPayDate({ rgmw: school.rgmw, date: null })
          ).unwrap();
        } catch {
          toast.error("تم التعطيل لكن فشل مسح تاريخ التمديد");
        }
      }
    } catch (err) {
      toast.error("فشل الطلب");
    }
  };

  const handlePhoneBlur = (e) =>
    dispatch(
      updateSchoolPhoneNumber({ rgmw: school.rgmw, phone: e.target.value })
    );
  const handleAnydeskBlur = (e) =>
    dispatch(
      updateSchoolAnydeskId({ rgmw: school.rgmw, anydeskid: e.target.value })
    );
  const handlePinBlur = (e) =>
    dispatch(
      updateSchoolPSEditPin({ rgmw: school.rgmw, psPin: e.target.value })
    );
  const handleExtend = async () => {
    if (!newPayDate) return toast.error("اختر تاريخاً");
    setIsUpdating(true);
    console.log("newPayDate:", newPayDate);
    const formatted = newPayDate;
    try {
      await dispatch(
        updateSchoolPayDate({ rgmw: school.rgmw, date: formatted })
      ).unwrap();
      toast.success("تم التمديد");
      setNewPayDate("");
      dispatch(fetchData(true));
    } catch {
      toast.error("خطأ في التمديد");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleToggleField = (field, current) => {
    const newValue = current === 1 ? 0 : 1;
    const actions = {
      close_employee: updateCloseEmployeeAction,
      close_malia: updateCloseMaliaAction,
      close_students: updateCloseStudentsAction,
      close_modeer: updateCloseModeerAction,
    };
    dispatch(actions[field]({ rgmw: school.rgmw, status: newValue })).then(
      () => {
        toast.success("تم التحديث");
        dispatch(fetchData(true));
      }
    );
  };

  const handleCanAddStoreToggle = () => {
    const currentStatus = school.can_add_store || 0;
    const newStatus = currentStatus === 1 ? 0 : 1;
    dispatch(updateCanAddStore({ rgmw: school.rgmw, status: newStatus }));
  };

  const handleSaveName = async () => {
    if (!newName.trim()) return toast.error("أدخل اسماً");
    try {
      const { updateSchoolName } = await import(
        "../../redux/slices/mainDataSlice"
      );
      await dispatch(
        updateSchoolName({ rgmw: school.rgmw, name: newName.trim() })
      );
      toast.success("تم تغيير الاسم");
      setShowEditNameModal(false);
    } catch {
      toast.error("فشل التغيير");
    }
  };

  const handleSendMessage = async () => {
    if (!messageText.trim()) return toast.error("أدخل نصاً");
    const token = JSON.parse(localStorage.getItem("userCredentials"))?.token;
    try {
      const response = await fetch(
        `https://api.alfares.cloud/api/alfares/schools/updateNote/${school.rgmw}/${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ noteforschool: messageText.trim() }),
        }
      );
      if (response.ok) {
        toast.success("تم إرسال الرسالة");
        setShowMessageModal(false);
      }
    } catch {
      toast.error("فشل الإرسال");
    }
  };
  
  const showLoginInfo = async () => {
    setShowLoginModal(true);
    setLoadingHistory(true);
    const token = JSON.parse(localStorage.getItem("userCredentials"))?.token;
    
    try {
      const response = await request.get(`/api/alfares/schools/login-history/${school.rgmw}/${token}`);
      const history = response.data.history || [];
      // Sort by action_time ascending on frontend as well to ensure correct order (oldest first)
      const sortedHistory = [...history].sort((a, b) => {
        const timeA = new Date(a.action_time).getTime();
        const timeB = new Date(b.action_time).getTime();
        if (timeA !== timeB) return timeA - timeB;
        // If times are equal, sort by id ascending
        return (a.id || 0) - (b.id || 0);
      });
      setLoginHistory(sortedHistory);
    } catch (error) {
      console.error("Error fetching login history:", error);
      setLoginHistory([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  const handleDeleteSchool = () => {
    toast(
      (t) => (
        <div style={{ fontFamily: "Cairo, sans-serif", textAlign: "center" }}>
          <div>سيتم حذف مدرسة : {school.schoolname}</div>
          <div
            style={{
              marginTop: 10,
              display: "flex",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <button
              onClick={async () => {
        try {
          await dispatch(deleteSchool(school.rgmw));
          toast.success("تم الحذف بنجاح");
          navigate("/schools");
        } catch {
          toast.error("فشل في الحذف");
                } finally {
                  toast.dismiss(t.id);
                }
              }}
              style={{
                backgroundColor: "#ef4444",
                color: "white",
                padding: "6px 14px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              نعم متأكد
            </button>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                backgroundColor: "#ccc",
                color: "black",
                padding: "6px 14px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              تراجع
            </button>
          </div>
        </div>
      ),
      { duration: 6000 }
    );
  };

  if (!school) {
    return (
      <div className="error-state">
        <h3>المدرسة غير موجودة</h3>
        <button className="btn" onClick={() => navigate("/schools")}>
          العودة للقمة
        </button>
      </div>
    );
  }

  return (
    <div className="school-details">
      {showLoginModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
          }}
          onClick={() => setShowLoginModal(false)}
        >
          <div
              className="login-history-modal"
              style={{
                borderRadius: "6px",
                padding: "24px",
                width: "100%",
                maxWidth: "900px",
                maxHeight: "90vh",
                overflow: "auto",
                direction: "rtl",
                border: "1px solid var(--border)",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 1)",
                background: "#ffffff",
              }}
              onClick={(e) => e.stopPropagation()}
            >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
                paddingBottom: "12px",
                borderBottom: "1px solid var(--border)",
              }}
            >
              <h3 style={{ margin: 0, color: "var(--accent)", fontWeight: "normal" }}>
                <span className="login-history-header-prefix">سجل الدخول - </span>{school.schoolname}
              </h3>
              <div style={{ 
                padding: "8px 16px", 
                background: "rgba(14, 165, 233, 0.1)", 
                borderRadius: "6px", 
                color: "var(--accent)",
                fontWeight: "normal"
              }}>
                <span className="login-history-header-prefix">عدد مرات تسجيل الدخول: </span>{loginHistory.filter(r => r.action_type === 1).length}
              </div>
            </div>

            {loadingHistory ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                جارٍ تحميل السجل...
              </div>
            ) : loginHistory.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px", color: "var(--muted)" }}>
                لا يوجد سجل دخول للمدرسة
              </div>
            ) : (
              <div style={{ 
                maxHeight: "450px", // تحديد الحد الأقصى للارتفاع لعرض 10 سجلات
                overflowY: "auto", // تفعيل التمرير العمودي
                overflowX: "auto" 
              }}>
                <table className="login-history-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 10 }}> {/* تثبيت رأس الجدول */}
                    <tr>
                      <th style={{ border: "1px solid var(--border)", padding: "6px", textAlign: "center", background: "#1e3a5f", fontWeight: "normal" }}>#</th>
                      <th style={{ border: "1px solid var(--border)", padding: "6px", textAlign: "right", background: "#1e3a5f", fontWeight: "normal" }}>وقت الإجراء</th>
                      <th style={{ border: "1px solid var(--border)", padding: "6px", textAlign: "center", background: "#1e3a5f", fontWeight: "normal" }}>الإجراء</th>
                      <th style={{ border: "1px solid var(--border)", padding: "6px", textAlign: "right", background: "#1e3a5f", fontWeight: "normal" }}>عنوان IP</th>
                      <th style={{ border: "1px solid var(--border)", padding: "6px", textAlign: "right", background: "#1e3a5f", fontWeight: "normal" }}>الجهاز</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loginHistory.map((record, index) => (
                      <tr key={record.id || index}>
                        <td style={{ border: "1px solid var(--border)", padding: "6px", textAlign: "center" }}>{index + 1}</td>
                        <td style={{ border: "1px solid var(--border)", padding: "6px" }}>
                          <div>
                            <span style={{ color: "var(--accent)", marginLeft: "8px" }}>{safeDay(record.action_time)}</span>
                            {safeISODate(record.action_time)}
                          </div>
                          <div style={{ color: "var(--muted)", fontSize: "12px" }}>{safeTime(record.action_time)}</div>
                        </td>
                        <td style={{ border: "1px solid var(--border)", padding: "6px", textAlign: "center" }}>
                          {record.action_type === 1 ? (
                            <FontAwesomeIcon icon={faArrowRightToBracket} style={{ color: "#22c55e", fontSize: "16px" }} />
                          ) : (
                            <FontAwesomeIcon icon={faArrowRightFromBracket} style={{ color: "#ef4444", fontSize: "16px" }} />
                          )}
                        </td>
                        <td style={{ border: "1px solid var(--border)", padding: "6px" }}>{record.ip_address || "-"}</td>
                        <td style={{ border: "1px solid var(--border)", padding: "6px" }}>{record.device_name || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="btn"
                onClick={() => setShowLoginModal(false)}
              >
                إغلاق
              </button>
            </div>
          </div>
        </div>
      )}
      <header
        className="school-details__header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid var(--border)",
          paddingBottom: "15px",
          direction: "rtl",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <div className="school-details__identity">
          <h1
            className="school-details__name"
            style={{
              fontWeight: "normal",
              marginBottom: "2px",
              fontSize: isMobileView ? "22px" : "24px",
            }}
          >
            {school.schoolname}
          </h1>

          {school.readnotetime && (
            <div
              style={{
                color: "var(--accent)",
                fontSize: "14px",
                opacity: 0.9,
              }}
            >
              آخر قراءة للملاحظة: {safeDate(school.readnotetime)}
            </div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
            marginTop: "22px",
          }}
        >
          <nav
            className="segmented"
            style={{
              background: "none",
              border: "none",
              display: "flex",
              gap: "0",
            }}
          >
            <button
              onClick={() => setActiveTab("profile")}
              className={`nav-square-btn ${
                activeTab === "profile" ? "active" : ""
              }`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                borderRadius: "0",
                border:
                  activeTab === "profile"
                    ? "1px solid var(--border)"
                    : "1px solid transparent",
                boxShadow: "none",
                fontSize: "14px",
              }}
            >
              <i
                className="fa-solid fa-id-card"
                style={{ color: "#0ea5e9" }}
              ></i>
              <span className="tab-text">ملف المدرسة</span>
            </button>

            <button
              onClick={() => setActiveTab("employees")}
              className={`nav-square-btn ${
                activeTab === "employees" ? "active" : ""
              }`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                borderRadius: "0",
                border:
                  activeTab === "employees"
                    ? "1px solid var(--border)"
                    : "1px solid transparent",
                boxShadow: "none",
                fontSize: "14px",
              }}
            >
              <i
                className="fa-solid fa-users-gear"
                style={{ color: "#6366f1" }}
              ></i>
              <span className="tab-text">الموظفون</span>
            </button>

            <button
              onClick={() => setActiveTab("thawabet")}
              className={`nav-square-btn ${
                activeTab === "thawabet" ? "active" : ""
              }`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                borderRadius: "0",
                border:
                  activeTab === "thawabet"
                    ? "1px solid var(--border)"
                    : "1px solid transparent",
                boxShadow: "none",
                fontSize: "14px",
              }}
            >
              <FontAwesomeIcon icon={faDatabase} style={{ color: "#8b5cf6" }} />
              <span className="tab-text">ثوابت المدرسة</span>
            </button>

            <Can module="schools" action="edit">
            <button
              onClick={() => setShowMessageModal(true)}
              className="nav-square-btn"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                borderRadius: "0",
                border: "1px solid transparent",
                boxShadow: "none",
                fontSize: "14px",
              }}
            >
              <FontAwesomeIcon
                icon={faEnvelopeOpenText}
                style={{ color: "#f59e0b" }}
              />
              <span className="tab-text">إرسال رسالة</span>
            </button>
            </Can>
          </nav>

          <div
            className="school-details__actions-row"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginRight: "10px",
              paddingRight: "10px",
              borderRight: "1px solid var(--border)",
            }}
          >
            <Tooltip content="تفصيل الدخول">
              <button
                onClick={showLoginInfo}
                className="btn school-details__edit-btn btn--icon-mobile"
             
                style={{
                  padding: "8px 15px",
                  fontSize: "14px",
                  borderRadius: "0",
                  background: "var(--panel-2)",
                  border: "1px solid var(--border)",
                  boxShadow: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <FontAwesomeIcon
                  icon={faHistory}
                  style={{ color: "#10b981" }}
                />
                <span className="btn-label">تفصيل الدخول</span>
              </button>
            </Tooltip>

            <Can module="schools" action="edit">
            <Tooltip content="تعديل الاسم">
              <button
                className="btn school-details__edit-btn btn--icon-mobile"
             
                style={{
                  padding: "8px 15px",
                  fontSize: "14px",
                  borderRadius: "0",
                  background: "var(--panel-2)",
                  border: "1px solid var(--border)",
                  boxShadow: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onClick={() => {
                  setNewName(school.schoolname);
                  setShowEditNameModal(true);
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
                <span className="btn-label">تعديل الاسم</span>
              </button>
            </Tooltip>
            </Can>

            <Can module="schools" action="delete">
            <Tooltip content="حذف المدرسة">
              <FontAwesomeIcon
                icon={faTrashCan}
                className="trash-anim-icon"
                onClick={handleDeleteSchool}
                style={{
                  color: "#ef4444",
                  cursor: "pointer",
                  fontSize: "22px",
                }}
             
              />
            </Tooltip>
            </Can>
          </div>
        </div>
      </header>

      <div className="school-details__body">
        {activeTab === "profile" && (
          <div className="profile-tab anim-fade-in">
            <div className="stats-grid">
              <Can
                module="schools"
                action="edit"
                fallback={
                  <div className="stat-card" style={{ cursor: "default" }}>
                    <FontAwesomeIcon
                      icon={school.onoff === "on" ? faToggleOn : faToggleOff}
                      className={
                        school.onoff === "on" ? "text-success" : "text-danger"
                      }
                      style={{ fontSize: "20px" }}
                    />
                    <span className="stat-card__label">حالة المدرسة</span>
                    <span
                      className={`stat-card__value ${
                        school.onoff === "on" ? "text-success" : "text-danger"
                      }`}
                    >
                      {school.onoff === "on"
                        ? "عاملة بنظام الفارس "
                        : "لا تعمل بنظام الفارس"}
                    </span>
                  </div>
                }
              >
              <div
                className="stat-card"
                onClick={() => handleToggle(school.onoff)}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={school.onoff === "on" ? faToggleOn : faToggleOff}
                  className={
                    school.onoff === "on" ? "text-success" : "text-danger"
                  }
                  style={{ fontSize: "20px" }}
                />
                <span className="stat-card__label">
                  حالة المدرسة (اضغط للتبديل)
                </span>
                <span
                  className={`stat-card__value ${
                    school.onoff === "on" ? "text-success" : "text-danger"
                  }`}
                >
                  {school.onoff === "on"
                    ? "عاملة بنظام الفارس "
                    : "لا تعمل بنظام الفارس"}
                </span>
              </div>
              </Can>
              <div className="stat-card">
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  style={{ color: "var(--accent)", fontSize: "20px" }}
                />
                <span className="stat-card__label">تاريخ استحقاق الدفع</span>
                <span
                  className="stat-card__value"
                  style={
                    school.onoff === "off"
                      ? { color: "#dc2626" }
                      : !school.paydate &&
                        school.payment_type !== "donation" &&
                        school.payment_type !== "discounted"
                      ? { color: "#16a34a" }
                      : undefined
                  }
                >
                  {school.onoff === "off"
                    ? "نسخة مغلقة"
                    : school.payment_type === "donation"
                    ? "نسخة مجانية"
                    : school.payment_type === "discounted"
                    ? "نسخة مخفضة"
                    : school.paydate || "نسخة مدفوعة"}
                </span>
              </div>
              <div className="stat-card">
                <FontAwesomeIcon
                  icon={faUserShield}
                  style={{ color: "var(--accent)", fontSize: "20px" }}
                />
                <span className="stat-card__label">الرقم الوطني للمدرسة</span>
                <span className="stat-card__value">
                  {school.rgmw}
                </span>
              </div>
              <div className="stat-card">
                <FontAwesomeIcon
                  icon={faRobot}
                  style={{ color: "var(--accent)", fontSize: "20px" }}
                />
                <span className="stat-card__label">رقم الاصدار الحالي</span>
                <span className="stat-card__value">
                  {school.alfares_ver || "?"}
                </span>
              </div>
              <div className="stat-card">
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  style={{ color: "var(--accent)", fontSize: "20px" }}
                />
                  <span className="stat-card__label">اسم المديرية</span>
                  <span className="stat-card__value">
                    {(() => {
                      const dirName =
                        thawabetRow?.AlModeeria_name_a ||
                        thawabetRow?.Modeeria_name_a ||
                        "غير محدد";
                      return placeName ? `${dirName} - ${placeName}` : dirName;
                    })()}
                  </span>
              </div>
            </div>

            <div
              className="management-card"
              style={{ paddingBottom: "50px", minHeight: "200px" }}
            >
              <h4 className="card-title">إعدادات المدرسة والتواصل</h4>
              <div className="form-grid">
                <div className="input-field">
                  <label>
                    <FontAwesomeIcon icon={faPhoneVolume} /> الهاتف
                  </label>
                  <input
                    type="text"
                    defaultValue={school.phonen || ""}
                    onBlur={handlePhoneBlur}
                    placeholder="رقم الهاتف"
                  />
                </div>
                <div className="input-field">
                  <label>
                    <FontAwesomeIcon icon={faDesktop} /> Anydesk ID
                  </label>
                  <input
                    type="text"
                    defaultValue={
                      anydeskData.find(
                        (x) => String(x.rgmw) === String(school.rgmw)
                      )?.anydeskid || ""
                    }
                    onBlur={handleAnydeskBlur}
                    placeholder="ID"
                  />
                </div>
                <div className="input-field">
                  <label>
                    <FontAwesomeIcon icon={faLock} /> كلمة مرور التعديل
                  </label>
                  <input
                    type="number"
                    defaultValue={school.psedit}
                    onBlur={handlePinBlur}
                  />
                </div>
                <div className="input-field">
                  <label>
                    <FontAwesomeIcon icon={faUserShield} /> كلمة مرور المدير
                  </label>
                  <input
                    type="text"
                    value={loadingPass ? "جارٍ..." : modeerPass}
                    disabled
                  />
                </div>
                <div className="input-field" style={{ gridColumn: "span 2" }}>
                  <label>
                    <FontAwesomeIcon icon={faCalendarAlt} /> تاريخ انتهاء الاشتراك الجديد
                  </label>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div style={{ flex: 1, minWidth: "120px" }}>
                      <UnifiedDatePicker
                        value={newPayDate || school.paydate || ""}
                        onChange={setNewPayDate}
                        portalId="root"
                        style={{ width: "100%" }} // لو الكومبوننت بدعم style
                      />
                    </div>

                    <Can module="schools" action="edit">
                    <button
                      onClick={handleExtend}
                      disabled={isUpdating}
                      style={{
                        height: "44px",
                        padding: "0 14px",
                        borderRadius: "6px",
                        border: "1px solid var(--border)",
                        background: "var(--panel-2)",
                        color: "var(--accent)",
                        fontFamily: "'Cairo', sans-serif",
                        fontSize: "14px",
                        cursor: isUpdating ? "not-allowed" : "pointer",
                        opacity: isUpdating ? 0.65 : 1,
                        whiteSpace: "nowrap",
                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                      }}
                      onMouseEnter={(e) => {
                        if (!isUpdating) {
                          e.currentTarget.style.borderColor = "var(--accent)";
                          e.currentTarget.style.boxShadow =
                            "0 0 0 2px color-mix(in srgb, var(--accent) 15%, transparent)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = "var(--border)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      {isUpdating ? "جارٍ..." : "تطبيق"}
                    </button>
                    </Can>

                    <Can module="schools" action="edit">
                    <Tooltip content="إزالة تاريخ الاستحقاق">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          toast(
                            (t) => (
                              <div
                                style={{
                                  fontFamily: "Cairo, sans-serif",
                                  textAlign: "center",
                                }}
                              >
                                <div>هل ترغب فعلاً بإزالة تاريخ الاستحقاق؟</div>
                                <div
                                  style={{
                                    marginTop: 10,
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "10px",
                                  }}
                                >
                                  <button
                                    onClick={async () => {
                                      try {
                                        await dispatch(
                                          changeStatusSchoolAction(school.rgmw)
                                        );
                                        toast.success(
                                          "تم إزالة تاريخ الاستحقاق بنجاح"
                                        );
                                        dispatch(fetchData());
                                      } catch {
                                        toast.error(
                                          "حدث خطأ أثناء إزالة التاريخ"
                                        );
                                      } finally {
                                        toast.dismiss(t.id);
                                      }
                                    }}
                                    style={{
                                      backgroundColor: "#e53935",
                                      color: "white",
                                      padding: "6px 14px",
                                      border: "none",
                                      borderRadius: "6px",
                                      cursor: "pointer",
                                      fontFamily: "Cairo, sans-serif",
                                    }}
                                  >
                                    نعم
                                  </button>
                                  <button
                                    onClick={() => toast.dismiss(t.id)}
                                    style={{
                                      backgroundColor: "#ccc",
                                      color: "black",
                                      padding: "6px 14px",
                                      border: "none",
                                      borderRadius: "6px",
                                      cursor: "pointer",
                                      fontFamily: "Cairo, sans-serif",
                                    }}
                                  >
                                    إلغاء
                                  </button>
                                </div>
                              </div>
                            ),
                            { duration: 8000, id: "clear-paydate-toast" }
                          );
                        }}
                     
                        style={{
                          height: "44px",
                          width: "44px",
                          padding: 0,
                          borderRadius: "6px",
                          border: "1px solid var(--border)",
                          background: "var(--panel-2)",
                          color: "#ef4444",
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = "#ef4444";
                          e.currentTarget.style.boxShadow =
                            "0 0 0 2px color-mix(in srgb, #ef4444 15%, transparent)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "var(--border)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </button>
                    </Tooltip>
                    </Can>
                  </div>
                </div>

                {(() => {
                  const secretary = allTeachers.find(
                    (t) =>
                      String(t.rgmw) === String(school.rgmw) &&
                      (t.W_Num === 3 || t.W_Num === 4)
                  );
                  return (
                    <div
                      className="input-field"
                      style={{ gridColumn: "span 2" }}
                    >
                      <label>
                        <FontAwesomeIcon icon={faUserTie} /> السكرتير/ة
                      </label>
                      <input
                        type="text"
                        value={secretary ? secretary.emp_name : "غير محدد"}
                        disabled
                      />
                    </div>
                  );
                })()}
              </div>
            </div>

            <div
              className="management-card"
              style={{
                paddingBottom: "10px",
                minHeight: "auto",
                background: "transparent",
                border: "none",
                boxShadow: "none",
              }}
            >
              <h4 className="card-title" style={{ marginBottom: "10px" }}>
                إعدادات الأقسام
              </h4>

              <div
                className="toggles-row"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "4px",
                  padding: "8px",
                  background: "rgba(255, 255, 255, 0.6)", // خلفية شفافة مخففة
                  borderRadius: "6px",
                  border: "1px solid rgba(148, 163, 184, 0.1)", // حدود خفيفة
                }}
              >
                {[
                  {
                    f: "close_employee",
                    i: faUserFriends,
                    c: "#3b82f6",
                    l: "شؤون الموظفين",
                  },
                  {
                    f: "close_students",
                    i: faGraduationCap,
                    c: "#10b981",
                    l: "شؤون الطلاب",
                  },
                  {
                    f: "close_malia",
                    i: faMoneyBill,
                    c: "#f59e0b",
                    l: "الشؤون المالية",
                  },
                  {
                    f: "close_modeer",
                    i: faUserTie,
                    c: "#8b5cf6",
                    l: "لمدير المدرسة",
                  },
                  {
                    f: "can_add_store",
                    i: faEdit,
                    c: "#ec4899",
                    l: "Refresh",
                  },
                ].map((item) => (
                  <div
                    key={item.f}
                    className="toggle-item-card"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "4px", // تقليل المسافة بين العناصر
                      padding: "4px 8px", // تقليل الهوامش الداخلية للعنصر
                      borderRadius: "6px",
                      transition: "all 0.3s ease",
                      cursor: "default",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={item.i}
                      className="toggle-item-icon"
                      style={{
                        color: item.c,
                        fontSize: "16px",
                        transition: "transform 0.3s ease",
                      }}
                    />
                    <span className="toggle-item-text" style={{ fontSize: "10px", fontWeight: "600" }}>
                      {item.l}
                    </span>
                    {item.f === "can_add_store" ? (
                      <Can module="schools" action="edit">
                      <FontAwesomeIcon
                        icon={(school[item.f] || 0) === 1 ? faToggleOn : faToggleOff}
                        onClick={handleCanAddStoreToggle}
                        style={{
                          fontSize: "20px",
                          cursor: "pointer",
                          color:
                            (school[item.f] || 0) === 1 ? "var(--success)" : "var(--muted)",
                          transition: "transform 0.2s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.transform = "scale(1.1)")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.transform = "scale(1)")
                        }
                      />
                      </Can>
                    ) : (
                      <Can module="schools" action="edit">
                      <FontAwesomeIcon
                        icon={school[item.f] === 0 ? faToggleOn : faToggleOff}
                        onClick={() => handleToggleField(item.f, school[item.f])}
                        style={{
                          fontSize: "20px", // تصغير زر التبديل قليلاً
                          cursor: "pointer",
                          color:
                            school[item.f] === 0
                              ? "var(--success)"
                              : "var(--muted)",
                          transition: "transform 0.2s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.transform = "scale(1.1)")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.transform = "scale(1)")
                        }
                      />
                      </Can>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <style>{`
          .toggle-item-card:hover {
            background: rgba(0, 0, 0, 0.04);
            transform: translateY(-2px);
          }
          .toggle-item-card:hover .toggle-item-icon {
            transform: scale(1.2) rotate(5deg);
          }
          @media (min-width: 900px) {
            .toggles-row {
              flex-wrap: nowrap !important;
              justify-content: space-around !important;
            }
          }
          /* Mobile: single row, 5 equal columns — never wrap */
          @media (max-width: 768px) {
            .toggles-row {
              display: grid !important;
              grid-template-columns: repeat(5, 1fr) !important;
              gap: 4px !important;
              padding: 8px !important;
              justify-items: stretch !important;
            }
            .toggle-item-card {
              padding: 8px 2px !important;
              gap: 4px !important;
              min-height: 0 !important;
              justify-content: center !important;
              background: transparent !important;
              border: none !important;
              width: 100% !important;
              min-width: 0 !important;
              box-sizing: border-box !important;
            }
            .toggle-item-card .toggle-item-icon {
              font-size: 15px !important;
            }
            .toggle-item-card .toggle-item-text {
              font-size: 9px !important;
              text-align: center !important;
              line-height: 1.2 !important;
              white-space: nowrap !important;
              overflow: hidden !important;
              text-overflow: ellipsis !important;
              max-width: 100% !important;
            }
            /* Compact toggle touch targets — fit in one row */
            .toggle-item-card .fa-toggle-on,
            .toggle-item-card .fa-toggle-off {
              font-size: 24px !important;
              padding: 2px !important;
              min-width: 0 !important;
              min-height: 0 !important;
            }
          }
          .thawabet-cards {
            grid-template-columns: repeat(4, 1fr) !important;
          }
          @media (max-width: 900px) {
            .thawabet-cards {
              grid-template-columns: repeat(2, 1fr) !important;
            }
          }
          @media (max-width: 500px) {
            .thawabet-cards {
              grid-template-columns: 1fr !important;
            }
          }
          .thawabet-table-wrapper {
            width: 100%;
            overflow-x: auto;
            background: var(--panel-2);
            border-radius: 6px;
            border: 1px solid var(--border);
            margin-top: 0;
            box-sizing: border-box;
          }
          .thawabet-table {
            width: 100%;
            border-collapse: collapse;
            text-align: right;
            font-size: 13px;
            table-layout: fixed;
          }
          .thawabet-table th {
            background: color-mix(in srgb, var(--panel-2) 90%, var(--accent));
            padding: 14px 16px;
            color: var(--accent);
            font-weight: 400;
            border-bottom: 1px solid var(--border);
            border-left: 1px solid var(--border);
            white-space: nowrap;
            font-size: 13px;
          }
          .thawabet-table th:first-child {
            border-right: none;
            width: 36%;
            min-width: 140px;
          }
          .thawabet-table th:last-child {
            width: 64%;
          }
          .thawabet-table td {
            padding: 12px 16px;
            border-bottom: 1px solid var(--border);
            border-left: 1px solid var(--border);
            color: var(--text);
            word-break: break-word;
            white-space: normal;
          }
          .thawabet-table td:first-child {
            border-right: none;
            color: var(--muted);
            font-weight: 400;
          }
          .thawabet-table tbody tr:hover {
            background: rgba(0, 0, 0, 0.03);
          }
          .thawabet-table tbody tr:last-child td {
            border-bottom: none;
          }
          @media (max-width: 768px) {
            .tab-text {
              display: none;
            }
            .login-history-header-prefix {
              display: none;
            }
            .login-history-table {
              font-size: 12px;
            }
            .login-history-table th,
            .login-history-table td {
              padding: 4px;
            }
            .toggle-item-text {
              display: none;
            }
          }
        `}</style>

        {activeTab === "thawabet" && (
          <div className="anim-fade-in" style={{ marginTop: "20px" }}>
            <div className="page-card" style={{ padding: "20px" }}>
              <h4 className="card-title" style={{ marginBottom: "16px" }}>
                ثوابت هذه المدرسة
              </h4>

              {!thawabetRow && (
                <div
                  className="text-center text-muted"
                  style={{ padding: "20px" }}
                >
                  لا توجد ثوابت مسجلة لهذه المدرسة.
                </div>
              )}

              {thawabetRow && (
                <>
                  <div
                    className="stats-grid thawabet-cards"
                    style={{
                      marginBottom: "20px",
                      gridTemplateColumns: "repeat(4, 1fr)",
                    }}
                  >
                    <div className="stat-card">
                      <span className="stat-card__label">الرقم الوطني</span>
                      <span className="stat-card__value">
                        {thawabetRow.school_rgmwtni || thawabetRow.rgmw || "—"}
                      </span>
                    </div>
                    <div className="stat-card">
                      <span className="stat-card__label">اسم المدرسة</span>
                      <span className="stat-card__value">
                        {thawabetRow.school_name || school.schoolname || "—"}
                      </span>
                    </div>
                    <div className="stat-card">
                      <span className="stat-card__label">اسم المديرية</span>
                      <span className="stat-card__value">
                        {thawabetRow.AlModeeria_name_a ||
                          thawabetRow.Modeeria_name_a ||
                          "—"}
                      </span>
                    </div>
                    <div className="stat-card">
                      <span className="stat-card__label">اسم المدير</span>
                      <span className="stat-card__value">
                        {thawabetRow.headMaster_Name || "—"}
                      </span>
                    </div>
                  </div>

                  <div className="thawabet-table-wrapper">
                    <table className="thawabet-table">
                      <tbody>
                        {Object.entries(thawabetRow)
                          .filter(
                            ([key]) => !IGNORED_THAWABET_FIELDS.includes(key)
                          )
                          .map(([key, value]) => (
                            <tr key={key}>
                              <td>{THAWABET_FIELD_LABELS[key] || key}</td>
                              <td>{renderThawabetValue(key, value)}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {activeTab === "employees" && (
          <div className="anim-fade-in">
            <EmployeeList embedded rgmw={rgmw} />
          </div>
        )}

        {/* Edit Name Modal */}
        {showEditNameModal && (
          <div
            className="pro-modal-overlay"
            onClick={() => setShowEditNameModal(false)}
          >
            <div
              className="pro-modal-content pro-modal-content--small"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="pro-modal-header pro-modal-header--row">
                <FontAwesomeIcon icon={faEdit} className="pro-modal-icon" />
                <h3 className="pro-modal-title">تعديل اسم المدرسة</h3>
              </div>
              <div className="pro-modal-body">
                <input
                  type="text"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  className="pro-modal-input"
                  placeholder="اسم المدرسة الجديد..."
                  autoFocus
                />
              </div>
              <div className="pro-modal-actions">
                <Can module="schools" action="edit">
                <button className="btn btn--primary" onClick={handleSaveName}>
                  حفظ التغييرات
                </button>
                </Can>
                <button
                  className="btn btn--secondary"
                  onClick={() => setShowEditNameModal(false)}
                >
                  إلغاء
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Message Modal */}
        {showMessageModal && (
          <div
            className="pro-modal-overlay"
            onClick={() => setShowMessageModal(false)}
          >
            <div
              className="pro-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="pro-modal-header">
                <FontAwesomeIcon icon={faMessage} className="pro-modal-icon" />
                <h3 className="pro-modal-title">
                  إرسال رسالة إلى {school.schoolname}
                </h3>
              </div>
              <div className="pro-modal-body">
                <textarea
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                  className="pro-modal-input"
                  style={{
                    height: "150px",
                    resize: "none",
                  }}
                  placeholder="اكتب رسالتك للمدرسة هنا..."
                  autoFocus
                />
              </div>
              <div className="pro-modal-actions">
                <Can module="schools" action="edit">
                <button
                  className="btn btn--primary"
                  onClick={handleSendMessage}
                >
                  إرسال الرسالة
                </button>
                </Can>
                <button
                  className="btn btn--secondary"
                  onClick={() => setShowMessageModal(false)}
                >
                  إغلاق
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <style>{`
        .school-details {
          height: calc(100% - 33px);
          display: flex;
          flex-direction: column;
          overflow: hidden; /* الحاوية الأساسية ثابتة */
          border: 1px solid rgba(148, 163, 184, 0.1); /* لون حدود أخف */
          border-radius: 6px;
          background: transparent;
        }
        .school-details__body {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 15px;
          overflow-y: auto; /* تمكين التمرير هنا */
          padding-right: 5px;
          padding-bottom: 20px; /* مساحة في الأسفل */
        }
        /* منع التمرير المزدوج في الحاوية الأب */
        .page-card {
          overflow: hidden !important;
        }
        /* إخفاء شريط التمرير من جسم الصفحة فقط */
        .school-details__body::-webkit-scrollbar {
          width: 0 !important;
          display: none !important;
        }
        .school-details__body {
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE/Edge */
        }
        .profile-tab {
          display: flex;
          flex-direction: column;
          gap: 15px; 
          padding-top: 15px; /* مسافة بين الإحصائيات والخط الفاصل */
        }
        .school-details__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 10px;
          border-bottom: 1px solid var(--border);
          flex-wrap: wrap;
          gap: 15px;
        }

        @media (max-width: 768px) {
            .school-details__header {
                flex-direction: column;
                align-items: flex-start !important; /* Align everything to the right (RTL) */
                text-align: right !important; /* Text align right */
                gap: 8px;
                padding-bottom: 8px;
            }

            .school-details__identity {
                align-items: flex-start !important; /* Align items to the start (right in RTL) */
                width: 100%;
            }

            /* Main Navigation Tabs + Actions Wrapper */
            .school-details__header > div:last-child {
                margin-top: 10px !important;
                display: flex !important;
                flex-direction: row !important;
                flex-wrap: nowrap !important; /* Force everything in ONE row */
                width: 100% !important;
                justify-content: space-between !important;
                align-items: center !important;
                gap: 5px !important;
                overflow-x: auto; /* Allow scrolling if screen is extremely small */
                padding-bottom: 5px;
            }

            .segmented {
                display: flex !important;
                flex-direction: row !important;
                flex-wrap: nowrap !important;
                flex: 1 !important;
                gap: 2px !important;
                min-width: 0 !important;
            }

            .nav-square-btn {
                padding: 6px 4px !important; 
                font-size: 10px !important; /* Increased by 1 (was 9px) */
                flex: 1 !important;
                min-width: 0 !important;
                flex-direction: column !important; /* Stack icon and text to save horizontal space */
                gap: 2px !important;
                border-radius: 6px !important;
            }

            /* Actions Row (Edit Name + Trash) */
            .school-details__actions-row {
                display: flex !important;
                flex-direction: row !important;
                align-items: center !important;
                gap: 5px !important;
                flex: none !important;
                border-right: 1px solid var(--border) !important;
                padding-right: 5px !important;
                margin-right: 5px !important;
            }

            .school-details__edit-btn {
                padding: 4px 8px !important;
                font-size: 10px !important;
                height: 28px !important;
                width: auto !important;
                white-space: nowrap !important;
                border-radius: 6px !important;
                flex: none !important;
            }

            .trash-anim-icon {
                font-size: 16px !important;
            }

            /* Four Toggles Row (Settings) */
            .toggles-row {
                display: grid !important;
                grid-template-columns: repeat(5, 1fr) !important;
                gap: 2px !important;
                padding: 8px 4px !important;
            }

            .toggles-row > div {
                width: 100% !important;
                gap: 4px !important;
            }

            .toggles-row span {
                font-size: 9px !important; // Smaller text to fit
                white-space: nowrap;
            }

            .toggles-row svg {
                font-size: 16px !important;
            }

            /* Reduced height for Stat Cards */
            .stat-card {
                min-height: 70px !important; /* Reduced from 100px */
                padding: 10px 15px !important; /* Reduced padding */
                gap: 4px !important;
            }

            .stat-card__value {
                font-size: 15px !important; /* Slightly smaller to fit better */
            }

            .stat-card__label {
                font-size: 11px !important;
            }

            /* Adjust Settings Grid and Inputs on Mobile */
            .form-grid {
                display: flex !important;
                flex-direction: column !important;
                gap: 12px !important;
            }

            .input-field {
                grid-column: span 1 !important; /* Reset any desktop grid span */
                width: 100% !important;
            }

            .input-field input, 
            .input-field select, 
            .input-field textarea {
                height: 40px !important; /* Slightly more compact height */
                font-size: 13px !important;
            }

            /* Fix hidden inputs in management card */
            .management-card {
                padding: 12px !important;
                height: auto !important;
                max-height: none !important;
                overflow: visible !important;
            }

            .school-details__body {
                overflow-y: auto !important; /* Ensure body can scroll to see all inputs */
                -webkit-overflow-scrolling: touch;
            }

            .school-details {
                overflow: visible !important; /* Allow the layout to expand as needed */
            }
        }

        .school-details__name {
          margin: 0;
          font-size: 24px;
          color: var(--accent);
          font-weight: normal;
        }
        .school-details__identity {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .text-success { color: #10b981; }
        .text-danger { color: #ef4444; }
        h1, h2, h3, h4, h5, h6 {
            font-weight: normal !important;
        }
        .nav-square-btn {
            background: transparent;
            border: none;
            color: var(--text);
            padding: 15px 25px;
            cursor: pointer;
            transition: all 0.2s;
            font-family: inherit;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .nav-square-btn:hover {
            background: var(--panel-2) !important;
            color: var(--accent);
        }
        .nav-square-btn.active {
            background: var(--panel-2) !important;
            color: var(--accent);
            border-bottom: 2px solid var(--accent) !important;
        }
        .trash-anim-icon {
            transition: transform 0.2s;
        }
        .trash-anim-icon:hover {
            animation: shake 0.5s infinite linear;
            filter: brightness(1.2);
        }
        
        /* تأثير الحركة عند الهوفر فقط لكافة أيقونات الأزرار */
        .nav-square-btn:hover i, 
        .nav-square-btn:hover svg,
        .btn:hover i,
        .btn:hover svg,
        .management-card .btn:hover i,
        .management-card .btn:hover svg {
            animation: hover-beat 0.8s infinite ease-in-out !important;
        }

        @keyframes hover-beat {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
        }

        @keyframes shake {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(10deg); }
            50% { transform: rotate(0deg); }
            75% { transform: rotate(-10deg); }
            100% { transform: rotate(0deg); }
        }
        .stats-grid {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 15px;
        }
        .stat-card {
            background: var(--panel-2);
            border: 1px solid var(--border);
            border-radius: 6px;
            padding: 16px 20px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 6px;
            text-align: right;
            direction: rtl;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            min-height: 100px;
        }
        .stat-card:hover {
            border-color: var(--accent);
            transform: translateY(-3px);
            box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.15);
            background: color-mix(in srgb, var(--panel-2) 95%, var(--accent));
        }
        .stat-card__label {
            font-size: 13px !important;
            color: var(--muted);
            opacity: 0.8;
            font-weight: 400;
        }
        .stat-card__value {
            font-size: 17px !important;
            font-weight: 400;
            color: var(--text);
        }
        @media (max-width: 1100px) {
            .stats-grid {
                grid-template-columns: repeat(3, 1fr);
            }
        }
        @media (max-width: 900px) {
            .stats-grid {
                grid-template-columns: repeat(2, 1fr);
            }
        }
        @media (max-width: 500px) {
            .stats-grid {
                grid-template-columns: 1fr;
            }
        }

        /* توحيد شكل مربع التاريخ مع باقي الحقول */
        .unified-date-picker-input {
            padding: 0 15px 0 115px !important;
            background: var(--panel-2) !important;
            border: 1px solid var(--border) !important;
            border-radius: 6px !important;
            color: var(--text) !important;
            height: 44px !important;
            box-sizing: border-box !important;
            font-size: 14px !important;
            width: 100% !important;
        }
        .unified-date-picker-input:focus {
            border-color: var(--accent) !important;
            box-shadow: none !important;
        }

        .reset-login-btn {
            position: absolute;
            top: 50%;
            left: 8px;
            transform: translateY(-50%);
            height: 30px;
            padding: 0 16px;
            font-size: 13px;
            border-radius: 6px;
            background: rgba(220, 38, 38, 0.08);
            color: #dc2626;
            border: 1px solid rgba(220, 38, 38, 0.25);
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            font-family: inherit;
        }

        .reset-login-btn:hover {
            background: rgba(220, 38, 38, 0.15);
            border-color: rgba(220, 38, 38, 0.5);
            color: #b91c1c;
            box-shadow: 0 4px 12px rgba(220, 38, 38, 0.15);
        }

        .extend-btn {
            position: absolute;
            top: 50%;
            left: 8px;
            transform: translateY(-50%);
            height: 30px;
            padding: 0 16px;
            font-size: 13px;
            border-radius: 6px;
            background: rgba(5, 150, 105, 0.08);
            color: #059669;
            border: 1px solid rgba(5, 150, 105, 0.25);
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            font-family: inherit;
            z-index: 10;
        }

        .extend-btn:hover:not(:disabled) {
            background: rgba(5, 150, 105, 0.15);
            border-color: rgba(5, 150, 105, 0.5);
            color: #047857;
            box-shadow: 0 4px 12px rgba(5, 150, 105, 0.15);
        }
        
        .extend-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
      `}</style>
    </div>
  );
}
